import {
  base_colorContentBorder,
  base_colorRaisedSurface,
  base_colorSurfaceSecondary,
  text_colorTextPrimary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { font_md } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  display: flex;
  flex-direction: column;
  background-color: ${base_colorRaisedSurface};
  border: 1px solid ${base_colorContentBorder};
  border-radius: 10px;
  overflow: hidden;

  .ContentCard {
    box-shadow: none;
  }

  .AlertPanel.warning {
    border-style: solid;
    border-width: 0 0 1px;
    border-color: ${base_colorContentBorder};
    border-radius: 0;

    .font-bold {
      ${font_md};
      color: ${text_colorTextPrimary};
    }

    .font-regular {
      ${font_md}
    }
  }

  .OrgVirtualCardsEnablePanel-bottom {
    padding: ${spacing(4)} ${spacing(10)} ${spacing(4)};
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    background-color: ${base_colorSurfaceSecondary};

    .connect-text {
      ${font_md}
    }

    .linktext-content {
      display: inline-block;
    }
  }
`
